
export enum ApiResourceDetailsLevelsEnum {
    metal = 'metal',
    minimal = 'minimal',
    full= 'full',
}


export type ApiRequestParams_pagination = {
    page_number?: number,
    page_size?: number
}


export type ApiRequestParams_detailsLevel = {
    details_level?: ApiResourceDetailsLevelsEnum,
}

export type ApiRequestParams_auctionsList = ApiRequestParams_detailsLevel & {
    page_number?: number,
    page_size?: number,
    completes_at?: -1|1
}



export type ApiRequestParams_lotsListBrowse = ApiRequestParams_pagination & ApiRequestParams_detailsLevel & {
    sorting_criteria?: string,
    filters?: string
}

export type ApiRequestParams_lotsSearch = ApiRequestParams_lotsListBrowse & {
  auction_completes_at?: number
}





type ApiBaseResource = {
    id: number,
    _class: string,
    created_at: number,
    updated_at?: number,
}

export type ApiPaginatedList<T_ListItem extends ApiBaseResource, T_SupplementalFields = {}> = {
    _class: 'PaginatedList',

    total_count: number,
    page_size: number,
    page_number: number, // starts at 1 (one)
    pages_count: number,

    data: Array<T_ListItem>,

    extra: null | {
        sorting_criteria?: string,
        filters?: string,
        ref_timestamp?: number,
    }
} & T_SupplementalFields


export type ApiLotsRunningTimedStaggeredList = {
    total_count: number,
    window_count?: number,
    ref_timestamp: number,
    cursor_timestamp: number,
    next_cursor_timestamp: number,
    data: Array<ApiResource_RunningTimedLot>,
}





export enum AuctionBiddingApprovalModeCode_Enum {
    manual = 'manual',
    auto_auction = 'auto_auction',
}


export enum BiddingWarrantStateCode_Enum {
    allowed = 'allowed',
    declined = 'declined',
    pending = 'pending',
    must_accept_terms = 'must_accept_terms',
    must_request = 'must_request',
    must_setup_account = 'must_setup_account',
    must_setup_card = 'must_setup_card',
    must_setup_custom_fields = 'must_setup_custom_fields',
}


export enum AuctionSegmentTypeCode_Enum {
    online = 'online',
    webcast = 'webcast',
}


export enum AuctionTimelineStateCode_Enum {
    completed = 'completed',
    running_stalled = 'running_stalled',
    running_live = 'running_live',
    upcoming = 'upcoming',
}

export enum AuctionTimelineStateCodeID_Enum {
    completed = 500,
    running_stalled = 310,
    running_live = 330,
    upcoming = 100,
}


export enum ItemMediaTypeCodeID_Enum {
    image = 10,
    video_youtube = 21,
    video_vimeo = 22,
}

export enum LotReserveStatusCode_Enum {
    no_reserve = 'no_reserve',
    reserve_not_met = 'reserve_not_met',
    reserve_met = 'reserve_met',
}



export type ApiResource_Auction = ApiBaseResource & {
    _class: 'Auction',

    site_id: number,

    auction_type_id: number,

    name: string,

    summary_html?: string,
    location_info_text?: string,
    viewing_info_text?: string,

    internet_buyer_premium_display_text?: string,
    onsite_buyer_premium_display_text?: string,

    details_page_html?: string,

    url_thumb_image: string,

    auction_timezone_name: string,

    starts_at: number,
    closing_starts_at: number,
    closing_ends_at: number,
    webcast_starts_at: number,
    completes_at: number,
    is_completed: boolean,

    timeline_state_id: number,
    current_segment_type_code: AuctionSegmentTypeCode_Enum,

    lots_count: number,

    currency_code: string,

    auction_ring_id?: number,
    auction_ring_name?: string,

    ring_primary_auction_id: number,
    ring_has_many_auctions: boolean,

    bidding_approval_mode_code: AuctionBiddingApprovalModeCode_Enum,
    bid_request_note_text: null|string,

    bid_increments_table: Array<Array<number>>,

    my_bidding_warrant_state_code?: BiddingWarrantStateCode_Enum,
    notification_sms_auction_timeline_enabled?: boolean,

    timed_jump_bids_allowed?: boolean,
    timed_bidding_extension?: number,
    timed_lots_staggering_ruleset?: {
        s1_group_size: number,
        s1_time_offset_seconds: number,
        s1_last_lot_number?: string,
        s2_group_size?: number,
        s2_time_offset_seconds?: number,
    },

    webcast_is_prepared: boolean,
    enter_webcast_screen_applink_url?: string,
};



export type ApiResource_LotMetal = ApiBaseResource & Partial<{

    auction_id: number,
    auction_timezone_name: string,

    number: string,
    number_sort: string,

    closes_at: number,
    completes_at: number,
    is_completed: boolean,
    has_round: boolean,

    linked_lots_group_id: null|number,

    inventory_item_id: number,

    inventory_refno: string,
    name: string,
    description_html: string,
    quantity: number,

    custom_sort: number,

    focal_media_file_url_thumb_image: string,
    video_url_thumb_image: string,
    video_url: string,

    bids_count: number,

    my_bid_is_leading_bid?: boolean,
    leading_bid_amount_cents: number,
    leading_bid_bidder_number: string,
    leading_bid_bidder_label: string,

    reserve_price_status_code?: string,

    starting_bid_amount_cents?: number,
    asking_bid_amount_cents?: number,

    my_max_bid_amount_cents?: number,
    my_bid_exists_in_history?: boolean,

    my_watched?: boolean,
}>;


export type ApiResource_CatalogLot = ApiResource_LotMetal & {
    auction?: ApiResource_Auction,
}


export type ApiResource_RunningTimedLot = Required<ApiResource_LotMetal> & {
    _class: 'RunningTimedLot',
}

export type ApiResource_WatchlistRunningLot = ApiBaseResource & Partial<ApiResource_LotMetal> & {
    _class: 'WatchlistRunningLot',
    auction: ApiResource_Auction,
}

export type ApiResource_SiteSearchLot = ApiBaseResource & Partial<ApiResource_LotMetal> & {
    _class: 'SiteSearchLot',
    auction: ApiResource_Auction,
}

export type ApiResource_WebcastLot = ApiBaseResource & {
    _class: 'WebcastLot',

    auction_id: number,

    number: string,

    name: string,

    description_html: string,

    focal_media_file_url_thumb_image: string,

    // FIXME: TODO: remove these from this response, and use separate API call for images
    video_url_thumb_image: string,
    video_url: string,
    images: Array<{ url: string, url_thumb: string }>,
}



export type ApiResource_ItemMediaFile_TypeDef = ApiBaseResource & {
    _class: "ItemMediaFile",

    ext_key: string,

    media_type_id: number,

    sort_idx: number,

    url: string,
    url_thumb_image: string,
    url_high_def: string,
};





export type ApiResource_Bid_TypeDef = ApiBaseResource & {
    _class: "Bid",

    recipient_id: number,
    auction_id: number,

    bidder_number: string,
    bidder_label: string,

    amount_cents: number,
    created_at: number,
    placed_at: number,

    is_auto: boolean,
    is_overridden: boolean,
};
